module.exports = __webpack_public_path__ + "images/application/templates/billing-957206cb.png";